import state from './moduleEnterpriseMapVesselState.js'
import mutations from './moduleEnterpriseMapVesselMutations.js'
import actions from './moduleEnterpriseMapVesselActions.js'
import getters from './moduleEnterpriseMapVesselGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
